<span class="ag-header-cell-text">
  {{ params.value | translate }}
  <!-- xux-hint component -->
  <xux-hint
    [description]="hintOptions.description"
    [container]="hintOptions.container"
    [placement]="hintOptions.placement"
    [customTooltipClasses]="hintOptions.customClasses"
  ></xux-hint>
</span>
